/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_feature_passkeys_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No passwords? No problem. Use FaceID or TouchID.`)
};

const zh_hans1_feature_passkeys_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`告别密码，使用指纹或面容识别`)
};

const zh_hant1_feature_passkeys_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`告別密碼，使用指紋或臉部辨識。`)
};

const fr_feature_passkeys_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de mot de passe ? Aucun souci. Utilisez Face ID ou Touch ID.`)
};

const de_feature_passkeys_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Passwörter? Kein Problem. Nutze Face ID oder Touch ID.`)
};

const ja_feature_passkeys_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワード不要。Face ID や Touch ID を使えます。`)
};

const ko_feature_passkeys_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호가 없어도 괜찮아요. Face ID 또는 Touch ID를 사용하세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const feature_passkeys_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.feature_passkeys_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("feature_passkeys_desc", locale)
	if (locale === "en") return en_feature_passkeys_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_feature_passkeys_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_feature_passkeys_desc(inputs)
	if (locale === "fr") return fr_feature_passkeys_desc(inputs)
	if (locale === "de") return de_feature_passkeys_desc(inputs)
	if (locale === "ja") return ja_feature_passkeys_desc(inputs)
	return ko_feature_passkeys_desc(inputs)
};